import { AfterViewInit, Component, EventEmitter, Output, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { CompanyService } from '../../../services/companies/company.service';
import { CompanyDto } from '../../../models/api/companyDto';
import { CompanySearchRequest } from '../../../models/api/companySearchRequest';

@Component({
  selector: 'app-add-connection-company-search',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatInputModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    NgxSpinnerModule,
    FormsModule
  ],
  templateUrl: './add-connection-company-search.component.html',
  styleUrls: ['./add-connection-company-search.component.scss']
})
export class AddConnectionCompanySearchComponent implements AfterViewInit {
  @Output() companySelected = new EventEmitter<CompanyDto | null>();

  private companyService = inject(CompanyService);
  private spinnerService = inject(NgxSpinnerService);

  dataSource = new MatTableDataSource<CompanyDto>([]);
  displayedColumns: string[] = ['actions', 'companyName', 'countryName', 'industryName'];
  pageSize: number = 5;
  selectedCompany: CompanyDto | null = null;

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  searchForm = {
    companyName: ''
  };

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  onSearch(): void {
    this.searchCompanies();
  }

  searchCompanies(): void {
    if (!this.searchForm.companyName || this.searchForm.companyName.trim() === '') {
      return;
    }

    const request: CompanySearchRequest = {
      companyName: this.searchForm.companyName,
      pageNumber: 1,
      pageSize: 100,
      sortBy: 'CompanyName',
      ascending: true
    };

    this.spinnerService.show();
    this.companyService.search(request).subscribe({
      next: (response) => {
        this.dataSource.data = response.data;
        if (this.paginator) {
          this.paginator.firstPage();
        }
        this.spinnerService.hide();
      },
      error: (error) => {
        console.error('Error searching companies:', error);
        this.spinnerService.hide();
      }
    });
  }

  onConnect(company: CompanyDto): void {
    if (this.selectedCompany?.id === company.id) {
      this.selectedCompany = null;
    } else {
      this.selectedCompany = company;
    }
    this.companySelected.emit(this.selectedCompany);
  }

  isSelected(company: CompanyDto): boolean {
    return this.selectedCompany?.id === company.id;
  }
}
